<template>
    <div class="message-table-list">
        <div class="tools-bar head-button">
            <div class="tools-btn-group">
                <el-button v-if="isShowUpdAllBtn" icon="el-icon-edit" type="primary" @click="handleAllMessageRead">全部设为已读</el-button>
                <el-button icon="el-icon-delete" type="danger" @click="handleAllMessageDelete">全部删除</el-button>
            </div>
        </div>
      <el-table :data="pageData" style="width: 100%;height: 390px; overflow-y: auto;" :border="true">
        <el-table-column prop="msgTitle" label="消息标题" :show-overflow-tooltip="true" >
            <template slot-scope="scope">
              <div  style="cursor:pointer;" @click.stop="linkPage(scope.row)">
                <template v-if="scope.row.msgStatus === 0">
                  <span style="font-size:16px;color:#f56c6c">!</span>
                  <b> {{scope.row.msgTitle}} </b>
                </template >
                <template v-else>
                    <span style="margin-left:14px;">{{scope.row.msgTitle}}</span>
                </template >
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="sendTime" label="产生时间" :show-overflow-tooltip="true" ></el-table-column>
        <el-table-column prop="msgType" label="消息类型" :show-overflow-tooltip="true"  >
          <template slot-scope="scope">
                <template v-if="scope.row.msgType === 0" >系统消息</template>
                <template v-if="scope.row.msgType === 1" >流程消息</template>
                <template v-if="scope.row.msgType === 2" >任务消息</template>
                <template v-if="scope.row.msgType === 3" >表单消息</template>
                <template v-if="scope.row.msgType === 4" >档案消息</template>
                <template v-if="scope.row.msgType === 5" >产品消息</template>
                <template v-if="scope.row.msgType === 6" >预警消息</template>
            </template>
        </el-table-column>
        <el-table-column   label="操作" width="250"> 
            <template slot-scope="scope">
                <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" circle @click="handleMessageDelete(scope.row)"></el-button>
            </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="end">
          <el-pagination
              background
              layout="total, prev, pager, next"
              :total="page.totalPageNum"
              :current-page="page.currentPage"
              :page-size="page.pageSize"
              @current-change="queryTableData"
          />
      </el-row>
    </div>
</template>

<script>
  export default {
      components: {
      },
      data () {
          return {
              tableColumns: [
                  {
                      id: '1',
                      prop: 'msgTitle',
                      label: '消息标题'
                  },
                  {
                      id: '2',
                      prop: 'sendTime',
                      label: '产生时间'
                  },
                  {
                      id: '3',
                      prop: 'msgTypeView',
                      label: '消息类型'
                  }
              ]
          };
      },
      props: {
          pageData: {
              type: Array
          },
          page: {
              type: Object
          },
          msgType: {
              type: [Number, String],
              default: ''
          },
          isShowUpdAllBtn: {
              type: Boolean,
              default: false
          }
      },
      created () {

      },
      methods: {
          queryTableData (currentPage) {
              this.$emit('queryTableData', {currentPage});
          },
          async handleMessageDelete (row) {
              this.$emit('handleMessageDelete', row);
          },
          async linkPage (row) {
              this.$emit('linkPage', row);
              row.msgStatus = 1;
          },
          async handleAllMessageDelete () {
              // console.log("===="+this.msgType);
              this.$emit('handleAllMessageDelete', this.msgType);
          },
          async handleAllMessageRead () {
              this.$emit('handleAllMessageRead', this.msgType);
          }
      }
  };
</script>
<style lang="less">
    .message-table-list {
        .head-button {
            float: right;
            margin-top: -10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/WarnMessage/WarnMessageTable.vue